module.exports = __webpack_public_path__ + "static/media/intro05.c4ba3f2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/intro05.jpg
// module id = 2025
// module chunks = 0